(function (Translator) {
    // xk
    Translator.add("rate_list.rate.bg_kbcbank", "Shuma KBC Bank", "EvpThemeBundle", "xk");
    Translator.add("recaptcha.description", "Ky mesazh synon t\u00eb verifikoj\u00eb n\u00ebse nj\u00eb person po shfleton dhe p\u00ebr t\u00eb shmangur sistemet automatike t\u00eb kontrollit", "EvpThemeBundle", "xk");
    Translator.add("recaptcha.title", "A jeni ju robot?", "EvpThemeBundle", "xk");
})(Translator);
